import React from 'react'

export const IconDownloadApp = (props = {}) => {
	const {size = 20, imgSize= 20, fill = "white"} = props
	return <>
		<svg xmlns="http://www.w3.org/2000/svg"
				 width={`${size}px`}
				 height={`${size}px`}
				 viewBox={`0 0 ${imgSize} ${imgSize}`}
				 fill="none"
		>
			<path
				d="M14.6083 8.8401L13.725 7.95627L10.625 11.0563V1.66602H9.375V11.0561L6.275 7.9561L5.39167 8.8401L10 13.4484L14.6083 8.8401ZM2.5 16.041V17.291H17.5V16.041H2.5Z"
				fill={fill}
			/>
		</svg>
	</>
}
